import type { HotelPensionPricingFormData } from '@/types/benefits/hotel/HotelPensionPricingSchema';

/**
 * Serializes form pension pricings for API submission (e.g. FormData or JSON).
 * Used by both create and edit hotel flows.
 */
export function serializePensionPricings(
  pricings: HotelPensionPricingFormData[] | undefined,
) {
  if (!pricings) return [];
  return pricings.map((card) => ({
    name: card.name ?? null,
    periods: (card.periods ?? []).map((period) => ({
      startDate: period.startDate ? new Date(period.startDate) : null,
      endDate: period.endDate ? new Date(period.endDate) : null,
      applicationDays: period.applicationDays ?? [],
    })),
    prices: (card.prices ?? []).map((price) => ({
      pensionType: price.pensionType,
      adultPrice: price.adultPrice != null ? Number(price.adultPrice) : null,
      childPrice: price.childPrice != null ? Number(price.childPrice) : null,
      adolescentPrice:
        price.adolescentPrice != null ? Number(price.adolescentPrice) : null,
    })),
  }));
}
